import { AccountServiceBase } from "../../config";
import { checkResponseErrors, makeRequestInit } from '../fetchHelper';

type PromiseWrapper = <T>(promise: Promise<T>) => PromiseLike<T>;

export class AnonServer {
    private _pw: PromiseWrapper;

    constructor(promiseWrapper: PromiseWrapper) {
        this._pw = promiseWrapper;
    }

    register(username: string, token: string, password: string) {

        const init = makeRequestInit('POST', {
            UserName: username,
            Token: token,
            Password: password,
        });

        var fp = fetch(AccountServiceBase + '/register', init);

        return this._pw(fp)
            .then(checkResponseErrors)
            .then(() => void (0));
    }

    forgotPassword(username: string) {

        const init = makeRequestInit('POST', {
            UserName: username,
        });

        var fp = fetch(AccountServiceBase + '/forgotpassword', init);

        return this._pw(fp)
            .then(checkResponseErrors)
            .then(() => void (0));
    }
}
